import { useState } from 'react';
import { isCollectionNameTaken } from '../lib/collection-name.js';
import { Dialog } from './dialog.js';

export function AddCollectionDialog({
  existingNames,
  onClose,
  onCreate,
}: {
  existingNames: string[];
  onClose: () => void;
  onCreate: (name: string) => Promise<void>;
}) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  const trimmed = name.trim();
  const isDuplicate = isCollectionNameTaken(trimmed, existingNames);
  const canSubmit = trimmed !== '' && !isDuplicate && !busy;

  function submit() {
    if (!canSubmit) return;
    setBusy(true);
    void onCreate(trimmed).catch(() => setBusy(false));
  }

  return (
    <Dialog onClose={busy ? () => undefined : onClose} aria-label="Add collection">
      <h2>Add collection</h2>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        <input
          className="input"
          value={name}
          autoFocus
          placeholder="Weeknight dinners"
          onChange={(event) => setName(event.target.value)}
        />
        {isDuplicate && (
          <p className="error-text" style={{ marginTop: 8 }}>
            A collection named “{trimmed}” already exists.
          </p>
        )}
        <div className="row" style={{ marginTop: 18 }}>
          <span className="spacer" />
          <button type="button" className="btn ghost" disabled={busy} onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn primary" disabled={!canSubmit}>
            {busy ? 'Adding…' : 'Add collection'}
          </button>
        </div>
      </form>
    </Dialog>
  );
}
